"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyCadstromUidRegex = exports.CadstromUidTypes = exports.CADSTROM_UUID_SUFFIX_PLACEHOLDER = void 0;
exports.isCadstromUidOfType = isCadstromUidOfType;
exports.cadstromUidRegex = cadstromUidRegex;
exports.generateCadstromUid = generateCadstromUid;
exports.regenerateCadstromUid = regenerateCadstromUid;
exports.regenerateRecordId = regenerateRecordId;
exports.getObjectTypeDefinitionFromUid = getObjectTypeDefinitionFromUid;
exports.cadstromUidSchema = cadstromUidSchema;
exports.looksLikeCadstromUid = looksLikeCadstromUid;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const CadstromObjectType_1 = require("./CadstromObjectType");
exports.CADSTROM_UUID_SUFFIX_PLACEHOLDER = Array(32).fill('0').join('');
exports.CadstromUidTypes = Object.values(CadstromObjectType_1.CadstromObjectType).reduce((acc, cur) => {
    acc[cur] = {
        name: cur,
        prefix: cur,
    };
    return acc;
}, {});
exports.AnyCadstromUidRegex = new RegExp(`^(${Object.values(exports.CadstromUidTypes)
    .map((t) => t.prefix)
    .join('|')})_[a-zA-Z0-9]+$`);
function isCadstromUidOfType(uid, type) {
    return cadstromUidRegex(type).test(uid);
}
const regexCache = new Map();
function cadstromUidRegex(objectType) {
    if (!regexCache.has(objectType)) {
        regexCache.set(objectType, new RegExp(`^${exports.CadstromUidTypes[objectType].prefix}_[a-zA-Z0-9]+$`));
    }
    return regexCache.get(objectType);
}
function generateCadstromUid(objectType, suffix, genMd5) {
    const type = exports.CadstromUidTypes[objectType];
    if (!type) {
        throw new Error(`Invalid object type: ${objectType}`);
    }
    if (suffix) {
        if (!genMd5) {
            throw new Error(`genMd5 argument is required when providing a suffix`);
        }
        suffix = genMd5(suffix.toString()).substring(0, 32).toLowerCase();
    }
    else {
        suffix = sigma_engine_shared_1.Utils.randomAlphaStr(36);
    }
    return `${type.prefix}_${suffix}`;
}
function regenerateCadstromUid(existingUid) {
    const separatorIndex = existingUid.indexOf('_');
    if (separatorIndex <= 0) {
        throw new Error(`Cannot regenerate id from malformed Cadstrom UID: ${existingUid}`);
    }
    const prefix = existingUid.slice(0, separatorIndex);
    return `${prefix}_${sigma_engine_shared_1.Utils.randomAlphaStr(36)}`;
}
function regenerateRecordId(existingId) {
    return existingId.indexOf('_') > 0 ? regenerateCadstromUid(existingId) : sigma_engine_shared_1.Utils.randomAlphaStr(36);
}
function getObjectTypeDefinitionFromUid(uid) {
    const [type, id] = uid?.split('_', 2) ?? [];
    if (!type) {
        throw new Error(`Invalid object id`);
    }
    if (!id || id.length < 32) {
        throw new Error(`Invalid object id: ${id}. Must be at least 32 characters long`);
    }
    if (/[^a-zA-Z0-9]/.test(id)) {
        throw new Error(`Invalid object id: ${id}. Must only contain alphanumeric characters`);
    }
    for (const definition of Object.values(exports.CadstromUidTypes)) {
        if (definition.prefix === type) {
            return definition;
        }
    }
    throw new Error(`Invalid object type: ${type}`);
}
function cadstromUidSchema(type) {
    return zod_1.z
        .string()
        .refine((value) => isCadstromUidOfType(value, type), { message: `Value must be a Cadstrom UID of type '${type}'` });
}
function looksLikeCadstromUid(value, objectType) {
    try {
        const definition = getObjectTypeDefinitionFromUid(value);
        if (objectType !== undefined) {
            return definition.name === objectType;
        }
        return true;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=CadstromUid.js.map